import http from "../../utils/http";

// 담당자 상담 리스트
export const getCounselingList = (type, params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/counseling/${type}/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 담당자 상담 생성
export const addCounseling = (counselingType, params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/counseling/${counselingType}`, { ...params, managerType: counselingType })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 담당자 상담 삭제
export const deleteCounseling = (counselingType, counselingIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/counseling/${counselingType}/${counselingIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 담당자 상담 수정
export const modifyCounseling = (counselingType, counselingIdx, params) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/counseling/${counselingType}/${counselingIdx}`, { ...params, managerType: counselingType })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCounseling = (counselingType, idx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/counseling/${counselingType}/${idx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const sendAlert = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/counseling/send/alert`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};